import { CpCommerceConstants } from '../../sdk/CPCommerce/cp-commerce-constants';
import * as fromDatatype from '../datatype-library';

export interface QueryParamsJsonDatatypeInterface extends fromDatatype.JsonDatatypeInterface {
  menu_icon?: string,
  query_params? : {
    [id: string] : string[],
  },
  state? : {
    auth_alternative_name?: string;
    requirest_auth?: boolean;
    bage_type?: CpCommerceConstants.MENU_BADGE_DISPLAY_TYPE;
    display_title?: boolean;
  },
  svg_icon?: {
    unfilled?: string;
    filled?: string;
  }
}

export interface bl_cms_menu_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_list_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  menu_link_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  target_url: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  menu_level: fromDatatype.NumericDatatypeInterface;
  property_json: QueryParamsJsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  layout_instance_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_menu_hdr_RowClass implements bl_cms_menu_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_list_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  menu_link_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  target_url: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  menu_level: fromDatatype.NumericDatatypeInterface;
  property_json: QueryParamsJsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  layout_instance_guid: fromDatatype.GuidDataFieldInterface;
}
